import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import "./style.css";

const Image = ({ slim, className, title, caption, src, ...rest }) => (
  <div className={cx(className, "image", { "image--slim": slim })}>
    <img className="image__elem" src={src} alt={title} {...rest} />
    {caption && <p className="image__caption">{caption}</p>}
  </div>
);

Image.propTypes = {
  slim: PropTypes.bool,
  title: PropTypes.string,
  caption: PropTypes.string,
  src: PropTypes.string.isRequired
};

export default Image;



// WEBPACK FOOTER //
// ./src/components/Image/index.js